import React, { useEffect, useState } from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useContext as usePaymentMethodsContext } from './Context';
import columns from './columns';
import Form from './Form';

export default function Table() {
  const {
    state: paymentMethodsState,
    actions: paymentMethodsActions,
    dispatch: paymentMethodsDispatch,
  } = usePaymentMethodsContext();

  const [defaultBillingInformation, setDefaultBillingInformation] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    paymentMethodsActions.load(paymentMethodsDispatch, paymentMethodsState.enterpriseId);
  }, []);

  const onAddBillingInformation = () => {
    paymentMethodsActions.prepareBillingInformation(paymentMethodsState.enterpriseId, (data) => {
      setDefaultBillingInformation(data);
      setShow(true);
    });
  };

  if (paymentMethodsState.paymentMethods === null) {
    return <LoadingPlaceholder placement="inline" />;
  }

  return (
    <>
      <div className="text-right">
        <Button
          onClick={() => onAddBillingInformation()}
          bsClass="btn btn-green"
        >
          Add Billing Information
        </Button>
      </div>
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={paymentMethodsState.paymentMethods}
          noDataComponent={
            <div className="mt20">No payment methods for this enterprise</div>
          }
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
      {defaultBillingInformation !== null && (
      <Form
        show={show}
        onHide={() => setShow(false)}
        initValue={defaultBillingInformation}
      />
      )}
    </>
  );
}
